module.exports = __webpack_public_path__ + "img/general-meter-electricity-meter-analog-md.9d458ee7.svg";